import React from "react";
import { CustomBtn, SecondaryBtn } from "../../Common/CustomBtn/index";

import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  BodyText,
  SubtitleText,
  StyledList,
  StyledDialogActions,
  ActionsBox,
} from "./PractitionerDisclaimer.styles";
import {
  DIALOG_TITLE,
  BODY_TEXT,
  CRITERIA_SUBTITLE,
  PROFILE_SUBTITLE,
  CANCEL_BTN_TEXT,
  BEGIN_BTN_TEXT,
  CRITERIA_ITEMS,
  PROFILE_ITEMS,
} from "./PractitionerDisclaimer.constants";

const PractitionerDisclaimer = ({ open, handleClose, onSave }) => {
  return (
    <StyledDialog open={open} onClose={handleClose}>
      <StyledDialogTitle>{DIALOG_TITLE}</StyledDialogTitle>

      <StyledDialogContent>
        <BodyText variant="body1">{BODY_TEXT}</BodyText>

        <SubtitleText variant="subtitle1">{CRITERIA_SUBTITLE}</SubtitleText>
        <StyledList>
          {CRITERIA_ITEMS.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </StyledList>

        <SubtitleText variant="subtitle1">{PROFILE_SUBTITLE}</SubtitleText>
        <StyledList>
          {PROFILE_ITEMS.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </StyledList>
      </StyledDialogContent>

      <StyledDialogActions>
        <ActionsBox>
          <CustomBtn
            smallR
            text={CANCEL_BTN_TEXT}
            noIcon
            width="50%"
            onClick={handleClose}
          />
          <SecondaryBtn
            smallR
            text={BEGIN_BTN_TEXT}
            width="50%"
            onClick={onSave}
          />
        </ActionsBox>
      </StyledDialogActions>
    </StyledDialog>
  );
};

export default PractitionerDisclaimer;
